// extracted by mini-css-extract-plugin
export default {"heading":"QueueSummaries_heading__oodnB","status":"QueueSummaries_status__dqQph","dot":"QueueSummaries_dot__Kdpnl"};